import { Workflow as WorkflowIcon } from "lucide-react";
import { defineModuleUi } from "@vixio/data";
import { lazyPage } from "@vixio/ui";
import "./api";

export * from "./api";

// Telas carregadas sob demanda: cada uma vira um arquivo à parte no build.
const WorkflowsPage = lazyPage(() => import("./WorkflowsPages"), "WorkflowsPage");
const WorkflowPage = lazyPage(() => import("./WorkflowsPages"), "WorkflowPage");

export default defineModuleUi({
  key: "workflows",
  title: "Automações",
  domain: "platform",
  icon: WorkflowIcon,
  menu: [{ path: "/configuracoes/automacoes", label: "Automações", minRole: "member", icon: WorkflowIcon, order: 65, keywords: "regras gatilho evento quando acontecer webhook aviso" }],
  routes: [
    { path: "/configuracoes/automacoes", element: <WorkflowsPage />, minRole: "member" },
    { path: "/configuracoes/automacoes/:id", element: <WorkflowPage />, minRole: "member" },
  ],
});
